export default class ProductTabs {
  constructor() {
    this.element = {
      tabs: document.querySelectorAll('.ProductTabs__Item'),
      panels: [...document.querySelectorAll('.ProductTabs__Panel')],
      faqHeaders: document.querySelectorAll('.handorgel__header'),
      faqContents: document.querySelectorAll('.handorgel__content'),
    };
  }

  init() {
    const { tabs, panels, faqHeaders, faqContents } = this.element;
    tabs.forEach((tab) => {
      const name = tab.querySelector('.js-tab').getAttribute('data-tab');
      if (name != 'Dimensions') {
        tab.addEventListener('click', () => {
          ['Item', 'Panel'].forEach((item) =>
            document
              .querySelector(`.ProductTabs__${item}--Active`)
              ?.classList?.remove(`ProductTabs__${item}--Active`)
          );
          tab.classList.add(`ProductTabs__Item--Active`);
          panels
            .find((panel) => panel.getAttribute('data-name') == name)
            ?.classList?.add(`ProductTabs__Panel--Active`);
        });
      }
    });

    if (faqHeaders) {
      faqHeaders.forEach((header, index) => {
        header.addEventListener('click', () => {
          if (faqContents[index].getAttribute('data-open') == '') {
            faqContents[index].removeAttribute('data-open');
          } else {
            document
              .querySelector('.handorgel__content[data-open]')
              ?.removeAttribute('data-open');
            faqContents[index].setAttribute('data-open', '');
          }
        });
      });
    }
  }
}
